import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";

// ⭐ 스타일 컴포넌트
const MovieCard = styled.div`
  background-color: ${(props) => props.theme.card};
  color: ${(props) => props.theme.text};
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.3);
  }
`;

const MovieImage = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 10px;
`;

const MovieTitle = styled.h2`
  font-size: 18px;
  margin: 10px 0;
  color: ${(props) => props.theme.text};

  a {
    text-decoration: none;
    color: inherit;

    &:hover {
      color: #16a085;
    }
  }
`;

const MovieInfo = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.text};
`;

const GenresList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const GenreItem = styled.li`
  background-color: #e74c3c;
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 5px;
`;

function Movie({ id, coverImg, rating, runtime, title, summary, genres }) {
  return (
    <MovieCard>
      <MovieImage
        src={coverImg}
        alt={title}
      />
      <MovieTitle>
        <Link to={`/movie/${id}`}>{title}</Link>
      </MovieTitle>
      <MovieInfo>
        <strong>⭐ 평점:</strong> {rating} | <strong>⏳ 상영시간:</strong>{" "}
        {runtime}분
      </MovieInfo>
      <MovieInfo>
        {summary.length > 100 ? `${summary.slice(0, 100)}...` : summary}
      </MovieInfo>
      <GenresList>
        {genres.map((g) => (
          <GenreItem key={g}>{g}</GenreItem>
        ))}
      </GenresList>
    </MovieCard>
  );
}

Movie.propTypes = {
  id: PropTypes.number.isRequired,
  coverImg: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  runtime: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  genres: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Movie;
